module.exports = __webpack_public_path__ + "img/dataType.1cdba28d.png";